<script lang="ts">
	//Components
	import IlluminanceThreshHoldWrapperG2 from './IlluminanceThreshHoldWrapperG2.svelte';

	export let device;
</script>

<IlluminanceThreshHoldWrapperG2 {device} type={'dark'} />
